import { request } from "./Request";
import { routes } from "../constants/constant.route";

const hoDashBoardRoutes = routes.HODASHBOARD;
const API_URL = process.env.VITE_APP_API_URL;

export default class HODashboardService {
  static getOffTakeSalesEntry(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `y=${filter.y}`;
    }
    if (filter.type) {
      qp += `&type=${filter.type}`;
    }
    if (filter.ref) {
      qp += `&ref=${filter.ref}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    if (filter.u) {
      qp += `&u=${filter.u}`;
    }
    // &m=${filter.m
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.GETOFFTAKESALESENTRY}${qp}`,
      null,
      null,
      null
    );
  }

  static getDirectIndirectData(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    if (filter.u) {
      qp += `&u=${filter.u}`;
    }
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.GETDIRECTINDIRECTDATA}${qp}`,
      null,
      null,
      null
    );
  }

  static getFleetStatusCount(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    if (filter.u) {
      qp += `&u=${filter.u}`;
    }
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.GETFLEETSTATUSCOUNT}${qp}`,
      null,
      null,
      null
    );
  }

  static filterAPI(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.FILTERAPI}${qp}`,
      null,
      null,
      null
    );
  }

  static downloadFleetStatusReport(filter, timeout) {
    let qp = "?";
    if (filter.u) {
      qp += `u=${filter.u}`;
    }
    if (filter.y) {
      qp += `&y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    if (filter.type) {
      qp += `&type=${filter.type}`;
    }
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.DOWNLOAD_FLEET_REPORT}${qp}`,
      null,
      null,
      null,
      timeout
    );
  }

  static downloadSalesReport(filter, timeout) {
    let qp = "?";
    if (filter.u) {
      qp += `u=${filter.u}`;
    }
    if (filter.y && filter.u) {
      qp += `&y=${filter.y}`;
    } else if (filter.y && !filter.u) {
      qp += `y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    if (filter.type) {
      qp += `&type=${filter.type}`;
    }

    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.DOWNLOAD_SALES_REPORT}${qp}`,
      null,
      null,
      null,
      timeout
    );
  }

  static downloadVerifiedSales(filter) {
    let qp = "?";
    if (filter.u) {
      qp += `u=${filter.u}&`;
    }
    if (filter.y) {
      qp += `y=${filter.y}&`;
    }
    if (filter.q) {
      qp += `q=${filter.q}&`;
    }
    if (filter.m) {
      qp += `m=${filter.m}&`;
    }
    if (filter.type) {
      qp += `type=${filter.type}&`;
    }

    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.DOWNLOAD_VERIFIED_SALES}${qp}`,
      null,
      null,
      null
    );
  }

  static getSalesTargetAchivemet(reqData) {
    return request(
      "GET",
      `${API_URL}${hoDashBoardRoutes.SALES_TARGET_ACIVEMENT}`,
      reqData,
      null,
      null
    );
  }
}
